import React, { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import PostCard from "../components/PostCard";
import CommentsDrawer from "../components/CommentsDrawer";
import { ArrowLeft } from "@phosphor-icons/react";

export default function PostDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [post, setPost] = useState(null);
  const [drawer, setDrawer] = useState(false);

  const load = useCallback(async () => {
    try { const { data } = await api.get(`/posts/${id}`); setPost(data); }
    catch (err) { console.error("post detail load failed", err); }
  }, [id]);

  useEffect(() => { load(); }, [load]);

  if (!post) return <div className="min-h-[100dvh] flex items-center justify-center text-cream/40 bg-ink">Loading…</div>;

  return (
    <div className="relative">
      <button onClick={() => nav(-1)} data-testid="post-detail-back" className="fixed top-5 left-5 z-40 w-11 h-11 rounded-full crystal-glass flex items-center justify-center text-cream">
        <ArrowLeft size={20} />
      </button>
      <PostCard post={post} onOpenComments={() => setDrawer(true)} onUpdate={load} />
      {drawer && <CommentsDrawer post={post} onClose={() => setDrawer(false)} onAdded={load} />}
    </div>
  );
}
